const baseUrl = "https://app.vulnvision.com/api";
export default baseUrl;
